import React, { useCallback, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { getDetailEntete, saveFileAvoir } from "../../Redux/reclamationReduce";
import jwt_decode from "jwt-decode";
import { t } from "react-multi-lang";
import Configuration from "../../configuration";

function DetailsAvoirReclamation({ obj }) {
  const dispatch = useDispatch();
  const location = useParams();
  const idReclamation = location.id;
  const token = localStorage.getItem("x-access-token");
  const decoded = jwt_decode(token);

  const [reclamation, setReclamation] = useState({});
  const [loader, setLoader] = useState(true);
  const [files, setFiles] = useState([]); // <-- plusieurs fichiers

  /* detailReclamation */
  const detailReclamation = useCallback(
    async (idReclamation) => {
      const dataReclamation = await dispatch(getDetailEntete({ idReclamation }));
      setReclamation(dataReclamation.payload);
      setLoader(false);
    },
    [dispatch]
  );

  useEffect(() => {
    detailReclamation(idReclamation);
  }, [idReclamation, detailReclamation]);

  /* Dropzone */
  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length === 0) return;
    setFiles((prev) => [...prev, ...acceptedFiles]); // concaténer
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "application/pdf, .pdf",
    multiple: true, // <-- plusieurs fichiers
  });

  const handleUpload = async () => {
    if (files.length === 0) {
      toast.warning("Veuillez sélectionner un ou plusieurs fichiers !");
      return;
    }

    const formData = new FormData();
    formData.append("idReclamation", idReclamation);
    files.forEach((file) => {
      formData.append("files", file); // même nom que côté backend
    });

    try {
      const result = await dispatch(saveFileAvoir(formData));

      if (result.payload && result.payload.files) {
        toast.success("Fichiers enregistrés avec succès !");
        setReclamation((prev) => ({
          ...prev,
          file_avoir: result.payload.enteteFile, // file[0] enregistré dans entete
        }));
        setFiles([]); // reset sélection
      } else {
        toast.error("Impossible de récupérer les fichiers enregistrés.");
      }
    } catch (error) {
      toast.error("Erreur lors de l'enregistrement des fichiers.");
    }
  };

  return (
    <>
      {loader ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        <Container fluid>
          <ToastContainer />
          <Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={() => window.history.back()}
              >
                <span className="btn-label">
                  <i className="fas fa-list"></i>
                </span>
                {t("list")}
              </Button>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                  <Card.Title as="h4">{"Détail avoir"}</Card.Title>
                </Card.Header>
                <Card.Body>
                  <br />
                  <br />
                  {reclamation.file_avoir ? (
                    reclamation.avoirs && reclamation.avoirs.length > 0 && (
                      <div>
                        {reclamation.avoirs.map((f, idx) => (
                          <iframe
                            key={idx}
                            src={`${Configuration.BACK_BASEURL}avoir/${f.file_avoir}`}
                            width="100%"
                            height="600px"
                            style={{ border: "none", marginBottom: "20px" }}
                            title={`PDF Viewer ${idx + 1}`}
                          ></iframe>
                        ))}
                      </div>
                    )
                  ) : (
                    <>
                      {(obj.user.id_role === 11 || obj.user.id_role === 5) ? (
                        <div
                          {...getRootProps()}
                          className="dropzone"
                          style={{
                            border: "2px dashed #3285c6",
                            padding: "20px",
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                        >
                          <input {...getInputProps()} />
                          {isDragActive ? (
                            <p>Déposez les fichiers ici ...</p>
                          ) : (
                            <p>
                              Glissez-déposez des fichiers PDF ici, ou cliquez
                              pour sélectionner
                            </p>
                          )}

                          {files.length > 0 && (
                            <ul style={{ marginTop: "10px", textAlign: "left" }}>
                              {files.map((f, idx) => (
                                <li key={idx}>{f.name}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ) : (
                        <p>Aucun fichier disponible.</p>
                      )}
                    </>
                  )}

                  {!reclamation.file_avoir && files.length > 0 && (obj.user.id_role === 11 || obj.user.id_role === 5) && (
                    <Button
                      className="mt-3 btn-info btn float-right"
                      variant="info"
                      onClick={handleUpload}
                    >
                      Enregistrer
                    </Button>
                  )}

                  <div className="clearfix"></div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
}

export default DetailsAvoirReclamation;
